/**
 * Created by CCristi on 3/4/17.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MissingRefreshTokenException = undefined;

var _IdentityProviderTokenExpiredException = require('./IdentityProviderTokenExpiredException');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let MissingRefreshTokenException = exports.MissingRefreshTokenException = function (_IdentityProviderToke) {
  _inherits(MissingRefreshTokenException, _IdentityProviderToke);

  function MissingRefreshTokenException() {
    _classCallCheck(this, MissingRefreshTokenException);

    return _possibleConstructorReturn(this, (MissingRefreshTokenException.__proto__ || Object.getPrototypeOf(MissingRefreshTokenException)).call(this, 'Missing refresh token'));
  }

  return MissingRefreshTokenException;
}(_IdentityProviderTokenExpiredException.IdentityProviderTokenExpiredException);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/Exception/MissingRefreshTokenException.js
// module id = 442
// module chunks = 0